import { CheckOutlined, ClockCircleOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import React from "react";

const GREY = "#8696A0";
const BLUE = "#34B7F1";

/**
 * Mirrors the state machine in the Flutter app's whatsapp_ticks.dart
 * (WhatsappTickResolver.forCounts) exactly, so the same message reads the
 * same way on web and mobile.
 *
 * `skipped` (no valid number) is excluded from the "everyone" denominator
 * throughout — those recipients were never going to receive anything, and
 * counting them would mean a group with even one unreachable member could
 * never show a full read receipt.
 */
export function resolveTickState(counts) {
  const c = counts || {};
  const reachableTotal = (c.total || 0) - (c.skipped || 0);

  if (reachableTotal <= 0) {
    return c.failed > 0 ? "failed" : "pending";
  }
  if (c.read >= reachableTotal) return "read";
  if ((c.delivered || 0) + (c.read || 0) >= reachableTotal) return "delivered";
  if ((c.sent || 0) + (c.delivered || 0) + (c.read || 0) > 0) return "sent";
  if (c.failed > 0 && c.failed >= reachableTotal && !c.queued) return "failed";
  return "pending";
}

const DoubleTick = ({ color, size }) => (
  <span style={{ position: "relative", display: "inline-block", width: size * 1.3, height: size }}>
    <CheckOutlined style={{ fontSize: size, color, position: "absolute", left: 0 }} />
    <CheckOutlined style={{ fontSize: size, color, position: "absolute", left: size * 0.35 }} />
  </span>
);

const WhatsappTicks = ({ counts, size = 13 }) => {
  const state = resolveTickState(counts);

  switch (state) {
    case "pending":
      return <ClockCircleOutlined style={{ fontSize: size, color: GREY }} />;
    case "sent":
      return <CheckOutlined style={{ fontSize: size, color: GREY }} />;
    case "delivered":
      return <DoubleTick color={GREY} size={size} />;
    case "read":
      return <DoubleTick color={BLUE} size={size} />;
    case "failed":
      return <ExclamationCircleFilled style={{ fontSize: size, color: "#f5222d" }} />;
    default:
      return null;
  }
};

export default WhatsappTicks;
